import React from 'react';
import { Container, Box, Typography, Button, Grid, Stack, Card, CardMedia } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

// ---- Image URLs ----
// Swap these with your hosted images. The layout matches the three screenshots provided.
const HERO_IMAGE = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1756910747/herocareer_r6itpn.jpg';
const CULTURE_IMG_1 = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1756911020/careerpic1_cg1mr1.png';
const CULTURE_IMG_2 = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1756911021/careerpic4_pgjqvq.png';
const CULTURE_IMG_3 = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1756911021/careerpic3_mhq9yp.png';
const CULTURE_IMG_4 ='https://res.cloudinary.com/ddhrdxc7d/image/upload/v1756911021/careerpic2_bqun17.png';

const VIEW_OPENINGS_URL = 'https://careers.dreamfindershomes.com/';

export default function CareersPage() {
  return (
    <>
      <LandingPageNav />

    {/* Hero Image */}
<Box sx={{ pt: { xs: 8, md: 10 } }}>
<Box
sx={{
position: 'relative',
minHeight: { xs: 320, md: 460 },
backgroundImage: `url(${HERO_IMAGE})`,
backgroundSize: 'cover',
backgroundPosition: 'center',
}}
/>
</Box>


{/* Hero Text Below Image */}


      {/* Gold CTA Bar */}
      <Box sx={{ bgcolor: '#b79a59', color: '#fff' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
          <Grid container alignItems="center" spacing={3}>
            <Grid item xs={12} md={8}>
              <Typography variant="h1" sx={{ mb: 1 }}>
                Ready to join the Jet HomeLoans team?
              </Typography>
              <Typography variant="heroSubheadline">
                View our career opportunities and find your place on our team.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} textAlign={{ xs: 'left', md: 'right' }}>
              <Button
                variant="outlined"
                size="large"
                href={VIEW_OPENINGS_URL}
                target="_blank"
                rel="noopener"
                sx={{
                  color: '#fff',
                  borderColor: '#fff',
                  px: 3,
                  py: 1.25,
                  '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' },
                }}
              >
                VIEW OPENINGS
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>

    

      {/* Culture Section */}
      <Box sx={{ bgcolor: '#33485a', color: '#fff', py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h2" sx={{ mb: 2 }}>
                Corporate Culture Programs and Events
              </Typography>
              <Stack spacing={2}>
                <Typography>
                  We pride ourselves on being a fun, challenging and rewarding place to work. We believe that great culture drives great success. Our culture is built around honesty, integrity and working together to have a positive impact on the people we serve. As a team, we encourage, motivate and lift each other to reach the heights of success.
                </Typography>
                <Typography>
                  Whether it’s exclusive trips for our top performers, networking and educational events, or team-building activities, our corporate culture committee is dedicated to providing incredible opportunities for team members to grow both personally and professionally.
                </Typography>
                <Typography>
                  Jet HomeLoans understands the value of creating a work-life balance and provides our team with wellness activities and campaigns throughout the year to encourage our team members to take time for themselves, their families and their health.
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <CardMedia component="img" image={CULTURE_IMG_1} alt="Culture 1" />
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <CardMedia component="img" image={CULTURE_IMG_2} alt="Culture 2" />
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <CardMedia component="img" image={CULTURE_IMG_3} alt="Culture 3" />
                  </Card>
                </Grid>
                  <Grid item xs={12} sm={6}>
                  <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <CardMedia component="img" image={CULTURE_IMG_4} alt="Culture 4" />
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Bottom CTA */}
      <Box sx={{ bgcolor: '#b79a59', color: '#fff' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 }, textAlign: 'center' }}>
          <Stack spacing={2} alignItems="center">
            <Typography variant="h2">
              Join our crew today!
            </Typography>
            <Typography variant="body1">
              View our career opportunities and find your place on our team.
            </Typography>
            <Button
              variant="outlined"
              size="large"
              href={VIEW_OPENINGS_URL}
              target="_blank"
              rel="noopener"
              sx={{ color: '#fff', borderColor: '#fff', px: 3, py: 1.25, '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
            >
              VIEW OPENINGS
            </Button>
          </Stack>
        </Container>
      </Box>

      <Footer />
    </>
  );
}

// Simple bullet component to mimic the dot bullets seen in the design
function Bullet({ children }) {
  return (
    <Stack direction="row" spacing={1.25} alignItems="flex-start">
      <Box sx={{ mt: '9px', width: 8, height: 8, borderRadius: '50%', bgcolor: 'text.secondary' }} />
      <Typography variant="body1">{children}</Typography>
    </Stack>
  );
}